// Image compression configuration types

export type CompressionMode = 'none' | 'auto' | 'always';

export interface CompressionConfig {
  mode: CompressionMode;
  threshold: number; // Size threshold in bytes (default: 100KB)
  maxWidth: number; // Max width for resizing (default: 1920px)
  maxHeight: number; // Max height for resizing (default: 1080px)
  quality: number; // Quality for lossy compression (0-1, default: 0.92)
  preserveExif: boolean; // Preserve EXIF data (default: false)
}

export interface CompressionResult {
  originalSize: number;
  compressedSize: number;
  compressionRatio: number;
  dataUrl: string;
  wasCompressed: boolean;
  format: string;
}

export const DEFAULT_COMPRESSION_CONFIG: CompressionConfig = {
  mode: 'auto',
  threshold: 100 * 1024, // 100KB
  maxWidth: 1920,
  maxHeight: 1080,
  quality: 0.92,
  preserveExif: false,
};
